// @flow
import React from 'react';
import { connect } from 'react-redux';
import PlayableItemPreview from './PlayableItemPreview';
import AlbumOneLineParticipantSummary from './AlbumOneLineParticipantSummary';
import mediaObjectStyles from '../util/MediaObject.css';
import { ENTITY_TYPE_ALBUM } from '../../constants';
import type { Album } from '../../shapes/types';
import * as analyticsActions from '../../actions/analytics';

function filterComposersOut(participants) {
  return participants.filter(participant => participant.type !== 'composer');
}

type OwnProps = {
  album: Album,
  onClick?: Function,
};

type DispatchProps = {
  trackPlayPausePressed: Function,
};

type Props = OwnProps & DispatchProps;

const AlbumListItem = ({ album, trackPlayPausePressed, onClick }: Props) => {
  const beforeTogglePlay = (item, playing) => {
    trackPlayPausePressed(
      {
        contextId: item.id,
        contextType: 'album',
      },
      playing
    );
  };

  return (
    <PlayableItemPreview
      item={{
        content: { ...album, type: ENTITY_TYPE_ALBUM },
        ...album,
      }}
      beforeTogglePlay={beforeTogglePlay}
      showPlayButton
      onClick={onClick}
    >
      <AlbumOneLineParticipantSummary
        className={mediaObjectStyles.performerSummary}
        participants={filterComposersOut(album.participants)}
      />
      <span className={mediaObjectStyles.performerSummary}>{album.copyright}</span>
    </PlayableItemPreview>
  );
};

const dispatchProps: DispatchProps = {
  trackPlayPausePressed: analyticsActions.trackPlayPausePressed,
};

export default connect(null, dispatchProps)(AlbumListItem);
